module.exports = __webpack_public_path__ + "01f43047/img/verified-icon.f93bbc14.svg";